import { render, staticRenderFns } from "./SvgViewer.vue?vue&type=template&id=490bef46&scoped=true&"
import script from "./SvgViewer.vue?vue&type=script&lang=js&"
export * from "./SvgViewer.vue?vue&type=script&lang=js&"
import style0 from "./SvgViewer.vue?vue&type=style&index=0&id=490bef46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490bef46",
  null
  
)

export default component.exports